import React, { useEffect, useState } from 'react'
import axios from "axios";
import { Tabs, Card, Form, Input, Button, Typography, Spin, Tag } from 'antd'
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  SaveOutlined
} from '@ant-design/icons'
import Histroy from './Histroy'
import { notify } from '../Customs/NotifyProvider';

const { Title, Text } = Typography

const Profile = ({ userKey }) => {

  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [orders, setOrders] = useState([]);


  const styles = {
    container: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
      gap: 16,
    },
    card: {
      border: '1px solid #eaeaea',
      borderRadius: 10,
      padding: 16,
      background: '#fff',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 12,
    },
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 6,
      fontSize: 14,
    },
  }

  const fetchOrders = async (userKey) => {
    try {
      setLoading(true)

      const res = await axios.get(
        `https://api.hemacabs.com/api/v1/product/orders/${userKey}`
      )

      if (res.data?.status && Array.isArray(res.data.data)) {
        setOrders(res.data.data)
      } else {
        setOrders([])
      }
    } catch (err) {
      console.error('Order fetch error:', err)
      setOrders([])
    }
  }

  // 🔹 Fetch Profile
  const getProfile = async (userKey) => {
    try {
      setLoading(true);

      const req = await axios.get(
        `https://api.hemacabs.com/api/v1/product/profile/${userKey}`
      );

      const data = req?.data?.data?.[0] || null;
      setUserData(data);

    } catch (error) {
      console.error(error);
      notify.error("Failed to load profile");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const userKey = localStorage.getItem('hc-user-key');

    if (userKey) {
      console.log("Found it!", userKey);
      getProfile(userKey);
      fetchOrders(userKey);

    } else {
      console.log("hc-user-key not found");
    }
  }, []);

  useEffect(() => {
    if (userKey) {
      getProfile(userKey);
      fetchOrders(userKey);

    }
  }, [userKey]);

  // 🔹 Set form values AFTER data comes
  useEffect(() => {
    if (userData) {
      form.setFieldsValue({
        name: userData.name,
        email: userKey,
        phone: userData.phone
      });
    }
  }, [userData, form, userKey]);

  // 🔹 Update Profile
  const handleUpdateProfile = async (values) => {
    try {

      const getForm =form.getFieldValue();
      console.log("getForm",getForm);
      

      setLoading(true);

      // const payload = {
      //   ...values,
      //   userKey // IMPORTANT
      // };



      const { data } = await axios.post(
        "https://api.hemacabs.com/api/v1/product/profile",
        getForm
      );

      if (data?.status) {
        notify.success(data.message || "Profile updated successfully");
        getProfile(userKey); // refresh
      } else {
        notify.error(data.message || "Failed to update profile");
      }

    } catch (error) {
      console.error(error);
      notify.error(
        error?.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  const items = [
    {
      key: '3',
      label: <Text style={{ fontSize: 16 }}>History</Text>,
      // children: <Histroy userKey={userKey} order={order} />,
      children: (
        <div style={styles.container}>
          {orders.map((item) => {
            const car = item.car ? JSON.parse(item.car) : {}
            const trip = item.trip ? JSON.parse(item.trip) : {}
            const pricing = item.pricing ? JSON.parse(item.pricing) : {}
            const paid = item.pay_type ? JSON.parse(item.pay_type) : {}

            return (
              <div key={item.id} style={styles.card}>
                <div style={styles.header}>
                  <strong>Ref. ID#{String(item.id).padStart(3, '0')}</strong>
                  <Tag color="blue">Paid Amount: {paid.pay_amount}</Tag>
                </div>

                <div style={styles.row}>
                  <span>Car</span>
                  <span>{car.car_name || '-'}</span>
                </div>

                <div style={styles.row}>
                  <span>Pickup Date</span>
                  <span>{trip.pickup_date || '-'}</span>
                </div>

                <div style={styles.row}>
                  <span>Pickup Time</span>
                  <span>{trip.pickup_time || '-'}</span>
                </div>

                <div style={styles.row}>
                  <span>Price</span>
                  <span>₹{pricing.finalPrice || 0}</span>
                </div>
                <div style={styles.row}>
                  <span><Tag color="green">Order status: {item.status}</Tag></span>
                </div>
              </div>
            )
          })}
        </div>
      ),
    },
    {
      key: '4',
      label: <Text style={{ fontSize: 16 }}>Personal Info</Text>,
      children: (
        <Card
          bordered={false}
          title={<Title level={3}>Profile Details</Title>}
          extra={
            <Button
              danger
              onClick={() => {
                localStorage.removeItem("hc-user-key")
                window.location.reload()
              }}
            >
              Logout
            </Button>
          }
        >
          <Spin spinning={loading}>
            <Form
              form={form}
              layout="vertical"
              size="large"
              onFinish={handleUpdateProfile}
            >
              <Form.Item
                label={<Text style={{ fontSize: 16 }}>Full Name</Text>}
                name="name"
                rules={[{ required: true, message: 'Name is required' }]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="Enter full name"
                />
              </Form.Item>

              <Form.Item
                label={<Text style={{ fontSize: 16 }}>Email</Text>}
                name="email"
                rules={[
                  { required: true, type: 'email', message: 'Valid email required' }
                ]}
              >
                <Input
                  prefix={<MailOutlined />}
                  placeholder="Enter email"
                  readOnly
                />
              </Form.Item>

              <Form.Item
                label={<Text style={{ fontSize: 16 }}>Phone</Text>}
                name="phone"
              >
                <Input
                  prefix={<PhoneOutlined />}
                  placeholder="Enter phone number"
                />
              </Form.Item>

              <Button
                type="primary"
                htmlType="submit"
                size="large"
                block
                icon={<SaveOutlined />}
                style={{ height: 48, fontSize: 16 }}
                loading={loading}
                onClick={handleUpdateProfile}
              >
                Update Profile
              </Button>
            </Form>
          </Spin>
        </Card>
      ),
    },
  ];

  return (
    <Card
      bordered={false}
      style={{
        maxWidth: '100%',
        margin: 0,
        padding: 0
      }}
    >
      <Tabs
        items={items}
        centered
        size="large"
        destroyInactiveTabPane
      />
    </Card>
  );
};

export default Profile;